export default {
    bind(el, binding) {
        el.addEventListener('keydown', binding.value);
    },
    unbind(el, binding) {
        el.removeEventListener('keydown', binding.value);
    }
};


// WEBPACK FOOTER //
// ./src/directives/keydown.js